/** @jsx jsx */
// eslint-disable-next-line
import React, { memo } from 'react'
import { css, jsx } from '@emotion/core'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { headerHeight } from '../../../constants'
import GameCloudLogo from '../../../assets/game-cloud-logo.png'
import GameCloudIcon from '../../../assets/game-cloud-icon.png'
import getTrackingMinutes from '../../../utils/getTrackingMinutes'
import minTommss from '../../../utils/minPlans'
import { history } from '../../App'

const styles = {}

styles.buttonMinutes = {
  height: '23px',
  padding: '6px 10px',
  marginLeft: '10px',
  textTransform: 'none',
  fontWeight: 'none',
  lineHeight: 'inherit',
  color: 'white',
  background: 'var(--game-cloud-purple)'
}

styles.container = css`
  height: ${headerHeight}px;
  width: 100%;
  background: rgba(35, 42, 59, 1);
  display: flex;
  align-items: center;
  padding: 0 50px;
  position: relative;
  z-index: 1;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`
styles.inputContainer = css`
  display: flex;
  align-items: center;
  width: calc(100% / 3);
`

styles.searchIcon = { marginRight: 10, color: 'white' }

styles.inputSearchContainer = css`
  display: flex;
  width: 100%;
`

styles.inputSearch = css`
  color: white;
  background: transparent;
  border: none;
  outline: 0;
  font-size: 16px;
  width: 100%;
  font-color: white;
  font-weight: 500;
  opacity: 1;
`
styles.closeIcon = {
  color: 'white',
  marginLeft: 10,
  fontSize: 19,
  cursor: 'pointer',
  marginRight: 2
}

styles.gameCloudLogoContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 3);
`

styles.gameCloudLogo = css`
  width: 200px;
`

styles.minutesContainer = css`
  display: flex;
  align-items: center;
  justify-content: end;
  width: calc(100% / 3);
`

styles.minutesBox = css` 
  display: flex;
  align-items: center;
  border-radius: 8px;
  border 1px solid var(--game-cloud-purple);
  padding: 5px 5px;
`

styles.minutesText = css`
  margin-right: 50px;
  color: white;
`

styles.minutesGameCloudIcon = css`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`

function getPlanMinutes(user) {
  const totalMinutes = getTrackingMinutes(user)

  return totalMinutes === -1 ? '∞' : `${minTommss(totalMinutes)}`
}

function onGetMoreMinutes() {
  if (history.location.pathname.includes('/shopping-cart')) {
    return
  }

  history.push('/shopping-cart?minutes_100_one_time')
}

function SearchBar(props) {
  return (
    <div css={styles.container}>
      <div css={styles.inputContainer}>
        <Icon style={styles.searchIcon}>search</Icon>
        <div
          css={styles.inputSearchContainer}
          style={{ borderBottom: props.searchValue ? '1px solid white' : '' }}
        >
          <input
            type="text"
            value={props.searchValue}
            onChange={props.changeSearchValue}
            css={styles.inputSearch}
            placeholder={window.I18n.t('admin.search')}
          />
          {!!props.searchValue && (
            <Icon style={styles.closeIcon} onClick={props.clearSearchValue}>
              highlight_off
            </Icon>
          )}
        </div>
      </div>

      <div css={styles.gameCloudLogoContainer}>
        <img src={GameCloudLogo} css={styles.gameCloudLogo} />
      </div>

      <div css={styles.minutesContainer}>
        <div css={styles.minutesBox}>
          <img css={styles.minutesGameCloudIcon} src={GameCloudIcon} />
          <div css={styles.minutesText}>
            {getPlanMinutes(props.user)} {window.I18n.t('admin.minutes')}
          </div>
          <Button
            variant="contained"
            type="submit"
            style={styles.buttonMinutes}
            onClick={onGetMoreMinutes}
          >
            {window.I18n.t('admin.getMoreMinutes')}
          </Button>
        </div>
      </div>
    </div>
  )
}

SearchBar.propTypes = {
  searchValue: PropTypes.string.isRequired,
  changeSearchValue: PropTypes.func.isRequired,
  clearSearchValue: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    trackingMinutes: state.auth.trackingMinutes
  }
}

export default connect(mapStateToProps)(SearchBar)
